import * as React from 'react';

import { mergeStyles } from '@cian/components';

import { loadYmapsApi } from '../../../../utils/ymaps';

export interface IObjectOnMapProps {
  height?: number;
  latlng: IYmapsCoord;
  zoom: number;
  ymapsUrlWithKey: string;
}

const placemarkIconUrl: string = require('./map_home_spot@2x.png');
const styles: {[key: string]: string} = require('./object_on_map.css');

export default class ObjectOnMap extends React.Component<IObjectOnMapProps, {}> {
  public static defaultProps = {
    height: 500,
  };

  private node: Element;
  private ymaps: IYmaps;
  private map: IYmapsMap;
  private placemark: IYmapsPlacemark;

  public componentDidMount() {
    loadYmapsApi(
      [
        'Map',
        'Placemark',
        'behavior.Drag',
        'behavior.DblClickZoom',
        'behavior.RightMouseButtonMagnifier',
        'behavior.MultiTouch',
        'control.ZoomControl',
      ],
      this.props.ymapsUrlWithKey,
    )
      .then((ymaps) => {
        this.ymaps = ymaps;

        this.map = new ymaps.Map(this.node, {
          center: this.props.latlng,
          zoom: this.props.zoom,
          behaviors: [
            'drag', 'dblClickZoom', 'rightMouseButtonMagnifier', 'multiTouch',
          ],
          controls: [
            new ymaps.control.ZoomControl(),
          ],
        });

        this.placemark = this.createPlacemark(this.props.latlng);
        this.map.geoObjects.add(this.placemark);
      });
  }

  public componentWillReceiveProps(nextProps: IObjectOnMapProps) {
    if (!this.map) {
      return;
    }

    if (this.props.latlng[0] === nextProps.latlng[0] && this.props.latlng[1] === nextProps.latlng[1]) {
      return;
    }

    this.map.geoObjects.remove(this.placemark);
    this.placemark = this.createPlacemark(nextProps.latlng);
    this.map.setCenter(nextProps.latlng, nextProps.zoom);
    this.map.geoObjects.add(this.placemark);
  }

  public center() {
    if (!(this.map && this.props.latlng[0] && this.props.latlng[1])) {
      throw Error('Map not initialized');
    }
    this.map.setCenter(this.props.latlng, this.props.zoom);
  }

  public render() {
    const { height } = this.props;
    return (
      <div {...mergeStyles(styles['height-container'], { height })}>
        <div
          className={styles['map-container']}
          ref={node => this.node = node}
        />
      </div>
    );
  }

  private createPlacemark(latlng: [number, number]) {
    return new this.ymaps.Placemark(latlng, {}, {
      iconLayout: 'default#image',
      iconImageHref: placemarkIconUrl,
      iconImageSize: [52, 48],
      iconImageOffset: [-20, -54],
    });
  }
}

export type ObjectOnMapConstructor = new (props: IObjectOnMapProps) => ObjectOnMap;



// WEBPACK FOOTER //
// ./src/bundles/common/components/object_on_map/object_on_map.tsx